import React from 'react'
import Footer from '../../Footer'
import fig1 from '../../../img/web/TED/fig1.gif'
import fig2 from '../../../img/web/TED/fig2.png'
import '../Proj.css'


export default class ProjTed extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
          
                <div className='proj-wrap-86'>
                    <div id='splat-title'>
                        <h1>TEDxNationalTaiwanUniversity Online Annual Event</h1>
                    </div>
                    <div className='proj-fig'>
                        <img src={fig1} />
                    </div>
                    <p>
                    Due to the COVID-19 situation of 2020, the annual talk event of TEDxNationalTaiwanUniversity had been cancelled.
                    The best we could do is to interview the speakers we initially invited. Despite the tight deadline due to the sudden decision of cancellation,
                     as part of the team, I volunteered to help organize the annual event into an independent website in a brief period.
                    </p>
                    <div className='proj-fig'>
                        <img src={fig2} />
                    </div>
                    <Footer back={true}/>
                </div>
            </div>
        )
    }
}